/**
 * Página pública de política de privacidad — Ley 21.719 (Sprint 18 P10).
 *
 * Contenido legal informativo. El texto del "responsable del tratamiento"
 * es provisional (Calbucura sin personalidad jurídica) y fácil de ajustar.
 * Enlazada desde el footer del portal y desde la sección "Mis derechos" de
 * Mis Datos.
 */
import { Card } from '../components/ui/Card';

export function Privacidad() {
  return (
    <div className="min-h-screen bg-bg-page">
      <div className="max-w-portal mx-auto p-4 md:p-8 lg:p-10 space-y-4">
        <header className="space-y-1">
          <h1 className="text-2xl font-medium text-text-primary">
            Política de privacidad
          </h1>
          <p className="text-sm text-text-muted">
            Cómo tratamos tus datos personales — Ley 21.719
          </p>
        </header>

        <Card>
          <h2 className="text-md font-medium text-text-primary mb-2">
            Tus datos están seguros con nosotros
          </h2>
          <p className="text-sm text-text-secondary">
            El Barrio Calbucura usa tus datos personales{' '}
            <strong>únicamente para fines de la administración del barrio</strong>:
            cobro y registro de cuotas, gestión de residentes y vehículos,
            accesos (citofonía y wifi), comunicaciones internas y recursos
            comunes. <strong>No vendemos ni transferimos tus datos a terceros</strong>{' '}
            con fines comerciales.
          </p>
        </Card>

        <Card>
          <h2 className="text-md font-medium text-text-primary mb-2">
            Tus derechos
          </h2>
          <ul className="text-sm text-text-secondary list-disc pl-5 space-y-1">
            <li>
              <strong>Acceso y portabilidad:</strong> puedes descargar una
              copia de tus datos en cualquier momento desde "Mis datos →
              Mis derechos sobre mis datos".
            </li>
            <li>
              <strong>Rectificación:</strong> puedes corregir tu email, celular
              y los datos de tu casa desde el portal.
            </li>
            <li>
              <strong>Cancelación (eliminación):</strong> puedes solicitar la
              eliminación de tu cuenta. La Comisión la evalúa y anonimiza tus
              datos personales, conservando solo la información contable
              necesaria para la transparencia de la asamblea, sin identificarte.
              Requiere haber dejado todas tus casas.
            </li>
          </ul>
        </Card>

        <Card>
          <h2 className="text-md font-medium text-text-primary mb-2">
            Proveedores que nos apoyan
          </h2>
          <p className="text-sm text-text-secondary">
            Para operar el portal usamos servicios externos que procesan datos
            con estándares de seguridad: alojamiento de la base de datos,
            envío de correos y la plataforma del portal. Estos proveedores
            actúan solo por encargo del barrio y no usan tus datos para fines
            propios.
          </p>
        </Card>

        <Card>
          <h2 className="text-md font-medium text-text-primary mb-2">
            Responsable del tratamiento
          </h2>
          <p className="text-sm text-text-secondary">
            La Comisión Barrio Calbucura, integrada por los vecinos que la
            componen. Para ejercer tus derechos o resolver dudas, escribe a{' '}
            <a
              href="mailto:administracion@calbucura.cl"
              className="text-orange hover:underline"
            >
              administracion@calbucura.cl
            </a>
            .
          </p>
          <p className="text-xs text-text-muted mt-3">
            Esta política puede actualizarse. Te avisaremos de cambios
            relevantes a través del portal.
          </p>
        </Card>
      </div>
    </div>
  );
}
